import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import _ from 'lodash';
import { dp, presetDp } from '../../../utils/shared.js';
import StorySeattle from './StorySeattle';
// import ReactIScroll from 'react-iscroll';
// import iScroll from 'iscroll';
import Slider from 'react-slick';
import BRSpan from '../../General/BRSpan';

class StoriesSeattle extends Component {
  constructor(props) {
    super(props);
    this._itemRefs = [];
    this._backButtonRef = null;
    this._elementsPerSlide = this.props.rows * this.props.columns;

    this.state = {
      renderedItems: [],
      showStory: false,
      hideStories: false,
      story: null,
      showSlick: false,
      currentSlide: 0
    }
  }

  componentDidMount() {
    this.setupElements();
    this.checkSwipeAnimation();
    setTimeout(() => {
      this.setupRefs();
    }, 250);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      this.setupElements();
      this.setupRefs();
    }
  }

  componentWillUnmount = () => {
    if (this._itemRefs.length > 0) {
      for (let i = 0; i < this._itemRefs.length; i++) {
        if (this._itemRefs[i]) {
          // this._itemRefs[i].el.removeEventListener('click', () => this.handleClick(this._itemRefs[i].data));
          if (this._itemRefs[i].length > 0) {
            for (let j = 0; j < this._itemRefs[i].length; j++) {
              if (this._itemRefs[i][j] && this._itemRefs[i][j].el) {
                this._itemRefs[i][j].el.removeEventListener('click', () => this.handleClick(this._itemRefs[i][j].data));
              }
            }
          }
        }
      }
    }
  }

  checkSwipeAnimation = () => {
    this.props.handleSwipeAnimation(9, this.props.items.length);
  }

  setupRefs = () => {
    if (this._itemRefs.length > 0) {
      for (let i = 0; i < this._itemRefs.length; i++) {
        if (this._itemRefs[i]) {
          // this._itemRefs[i].el.addEventListener('click', () => this.handleClick(this._itemRefs[i].data));
          if (this._itemRefs[i].length > 0) {
            for (let j = 0; j < this._itemRefs[i].length; j++) {
              if (this._itemRefs[i][j] && this._itemRefs[i][j].el) {
                this._itemRefs[i][j].el.addEventListener('click', () => this.handleClick(this._itemRefs[i][j].data));
              }
            }
          }
        }
      }
    }
  }

  setupBackButtonRef = () => {
    if (this._backButtonRef) {
      this._backButtonRef.addEventListener('click', () => this.handleBackButtonClick());
    } else {
      setTimeout(() => {
        this.setupBackButtonRef();
      }, 100)
    }
  }

  handleBackButtonClick = () => {
    if (this._backButtonRef) {
      this._backButtonRef.removeEventListener('click', () => this.handleBackButtonClick());
    }
    this._backButtonRef = null;
    this.setState({
      showStory: false,
      story: null
    });
    setTimeout(() => {
      this.setState({
        hideStories: false
      });
      setTimeout(() => {
        this.setState({
          showSlick: true
        })
      }, 300)
      this.setupRefs();
    }, 450)
  }

  handleClick = (data) => {
    let story = _.find(this.props.items, { id: data.id });
    this.setState({
      hideStories: true
    });
    setTimeout(() => {
      this.setState({
        showStory: true,
        story: story
      });
      this.setupBackButtonRef();
    }, 450);
  }

  setupElements = () => {
    let groups = [];
    let groupSlides = [];
    let items = _.orderBy(this.props.items, [item => item.sorting_name.toLowerCase()], ['asc']);
    for (let i = 0; i < items.length; i++) {
      if (((i !== 0) && ((i + 1) % this._elementsPerSlide === 0)) || (i === items.length - 1)) {
        groupSlides.push(items[i]);
        if (groupSlides.length < this._elementsPerSlide) {
          for (let j = groupSlides.length; j < this._elementsPerSlide; j++) {
            groupSlides.push(null);
          }
        }
        groups.push(groupSlides);
        groupSlides = [];
      } else {
        groupSlides.push(items[i]);
      }
    }

    this.renderSlides(groups);
  }

  renderSlides = (groups) => {
    try {
      let renderedItems = groups.map((group, i) => {
        this._itemRefs[i] = [];
        // let topRatio = 0;
        let row = [];
        let rows = [];
        for (let j = 0; j < group.length; j++) {
          let slide = group[j];
          let marginLeft = 0;  
                  
          if (j > 0 && (j % this.props.columns !== 0)) {
            marginLeft = 0.0225 * this.props.regionWidth;
          } else {
            marginLeft = 0;
          }
          
          let image = presetDp('stories', _.get(slide, 'contents.images[0]', null), this.props.screen);

          if (slide) {
            let renderedSlide = (
              <div key={j} ref={el => this._itemRefs[i][j] = { el: el, data: { id: slide.id } }} style={{ position:"relative", marginLeft: marginLeft, float:"left", height:0.09 * this.props.regionWidth, display:"flex", justifyContent:"center", alignItems:"flex-end", minWidth:"25%", maxWidth:"25%" }}>
                <img src={image} style={{ maxWidth:0.10125 * this.props.regionWidth, maxHeight:0.074925 * this.props.regionWidth }} alt=""/>
                <div style={{ position:"absolute", bottom:-(0.0468 * this.props.regionWidth), width:0.10125 * this.props.regionWidth, textAlign:"center", display:"flex", justifyContent:"center", minHeight:0.04166666666666666667 * this.props.regionWidth, maxHeight: 0.04166666666666666667 * this.props.regionWidth, overflow:"hidden" }}>
                  <div className="noselect" style={{ fontSize:0.0084 * this.props.regionWidth }}><BRSpan preWrap str={slide.name.toUpperCase()}/></div>
                </div>
              </div>
            );
            row.push(renderedSlide);
          }

          if (((j + 1) % this.props.columns === 0 && j > 0)) {
            // if (rows.length > 0) {
            //   topRatio = 0.027 * this.props.regionWidth;
            // }
            let renderedRow = (
              <div style={{ position:"relative", display:"flex", alignItems:"center", justifyContent:"center", width: 0.36 * this.props.regionWidth, height:0.10125 * this.props.regionWidth, marginBottom: 0.044 * this.props.regionWidth }}>
                {row}
              </div>
            );
            rows.push(renderedRow);
            row = [];
          }
        }
        
        return rows;
      });

      let slideGroup = [];
      let rows = [];
      for (let i = 0; i < renderedItems.length; i++) {
        rows.push(renderedItems[i]);
        if ((i + 1) % this._elementsPerSlide || i === this._elementsPerSlide.length - 1) {
          slideGroup.push((
            <div style={{ position:"relative" }} key={i}>
              {rows}
            </div>
          ));
          rows = [];
        }
      }
  
      this.setState({
        renderedItems: slideGroup
      });

      setTimeout(() => {
        this.setState({
          showSlick: true
        });
      }, 300);
    } catch(e) {
      console.log(e);
    }
  }

  render() {
    let dots = this.state.renderedItems.length > 1 ? true : false;
    let settings = {
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      useCSS: true,
      dots: dots,
      dotsClass: "story-seattle-slick-vertical",
      verticalSwiping: true,
      vertical: true,
      initialSlide: this.state.currentSlide,
      afterChange: current => {
        this.props.cancelSwipeAnimation();
        this.setState({ currentSlide: current });
      }
    };
    const backButton = dp(this.props.screen, null, { path:'/img/seattle/general/', file_name:'back.png' });
    let displayStories = this.state.hideStories ? "none" : "table-cell";

    return (
      <div style={{ width:"100%", height:"100%", display:"flex", alignItems:"center", justifyContent:"center" }}>
        <CSSTransitionGroup
          component='div'
          className="fastfadedelay"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div style={{ position:"absolute", display:"table", left: 0, width:"100%", height: 0.52 * this.props.regionWidth }} key={this.state.hideStories}>
              {
                !this.state.hideStories ?
                <div style={{ position:"relative", width:"90%", height: 0.41 * this.props.regionWidth, textAlign:"center", display: displayStories, marginLeft:"auto", marginRight:"auto", verticalAlign:"middle" }} >
                  <div style={{ maxHeight:.0902 * this.props.regionWidth, overflow:"hidden" }}>
                    <div className="noselect" style={{ fontSize:0.020 * this.props.regionWidth }}><BRSpan preWrap str={this.props.parent.name.toUpperCase()}/></div>
                  </div>
                  <div style={{ height:0.3958 * this.props.regionWidth, display:"flex", justifyContent:"center", alignItems:"center", marginTop: .017 * this.props.regionWidth }}>
                    {
                      this.state.renderedItems && this.state.renderedItems.length > 0 ?
                      <div style={{ maxWidth: 0.36 * this.props.regionWidth }}>
                        <Slider ref={el => this._slickRef = el} {...settings}>
                        {this.state.renderedItems}
                        </Slider>
                      </div>
                      :null
                    }
                  </div>
                </div>
                :null
              }
          </div>
        </CSSTransitionGroup>

        <CSSTransitionGroup
          component='div'
          className="fastfadedelay"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.showStory}>
            {
              this.state.showStory ?
              <div style={{ position:"absolute", left: 0, width:"100%", height:"100%" }}>
                <div>
                  <StorySeattle
                    item={this.state.story}
                    screen={this.props.screen}
                    regionWidth={this.props.regionWidth}
                    handleSwipeAnimation={this.props.handleSwipeAnimation}
                    cancelSwipeAnimation={this.props.cancelSwipeAnimation}
                  />
                </div>
              </div>
              :null
            }
          </div>
        </CSSTransitionGroup>
        <CSSTransitionGroup
          component='div'
          className="fastfadedelay"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          {
            this.state.showStory ? 
            <div key={this.state.showStory} ref={reactComponent => this._backButtonRef = reactComponent}>
              <img src={backButton} style={{ position:"absolute", left: 0, bottom: .02777777777777777778
 * this.props.regionWidth, width:0.050 * this.props.regionWidth }} alt=""/>
            </div>
            :null
          }
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default StoriesSeattle;


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/StoriesSeattle.jsx